import { Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"
import { removeUndefined } from "@tfg/types/schemas/utils"

import { useFindProductTypeValues } from "~/gen/api"

interface Props {
  filtersValue: filtersValidationType
  setFiltersValue: Dispatch<SetStateAction<filtersValidationType>>
}

export const ProductTypeFilter = ({
  setFiltersValue,
  filtersValue,
  ...props
}: Props) => {
  const { t } = useTranslation("products")
  const { data: productTypeValues, isLoading } = useFindProductTypeValues({
    ...removeUndefined(filtersValue),
  })

  return (
    <Select
      // defaults
      w={150}
      size="xs"
      clearable
      searchable
      isLoading={isLoading}
      // overrides
      {...props}
      // managed
      data={productTypeValues?.data.map((type) => ({
        value: type,
        label: type,
      }))}
      value={filtersValue.type ?? null}
      onChange={(value) =>
        setFiltersValue({ ...filtersValue, type: value ?? undefined })
      }
      placeholder={t("lists.placeholders.type")}
    />
  )
}
